import React from "react";
import { useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import NumberFormatting from "../../helper/NumberFormatting";
import {
  debtMoneyActions,
  getDebtMoneyById,
  postDebtMoney,
} from "../../../redux/reducer/debtMoney/debtMoneyReducer";
// import moment from "moment";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function FarmerDebtMoneyTambah() {
  // Navigate
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const farmer = useSelector((state) => state.farmer.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerId: "",
    submissionDate: "",
    amount: "",
    tenor: "",
  });

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          data: {
            farmerId: formData.farmerId,
            debtDetails: {
              submissionDate: formData.submissionDate,
              amount: formData.amount,
              remainingAmount: formData.amount,
              tenor: formData.tenor,
            },
            paidDetails: [],
          },
          token: token,
        };
        dispatch(postDebtMoney(data)).then((res) => {
          if (res.payload.status === 201) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getDebtMoneyById(dataGetById)).then((result) => {
              dispatch(debtMoneyActions.addDebtMoney(result.payload.data));
              toast.success(res.payload.message);
              navigate("/petani/hutang");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      }
    }
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          TAMBAH HUTANG PETANI
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              onChange={handleChange}
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {farmer.docs.length > 0 ? (
                farmer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TANGGAL HUTANG
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              type="date"
              name="submissionDate"
              onChange={handleChange}
              value={formData.submissionDate}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              JUMLAH
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: <></>,
              }}
              error={false}
              onChange={handleChange}
              value={formData.amount.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              name="amount"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              SISA HUTANG
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              disabled={true}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: <></>,
              }}
              error={false}
              onChange={handleChange}
              value={formData.amount.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              name="amount"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TENOR
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              onChange={handleChange}
              value={formData.tenor}
              name="tenor"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/hutang")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
